/**
 * ONE place that turns a stored STYLE (look) key into a customer-facing name.
 *
 * `card_requests.style` holds the internal key (`bitmoji_inspired`). The
 * customer-facing name lives on the style row (`style_taxonomy_config.
 * display_name` = "Cardmoji"), so any surface rendering a style name reads it
 * from here instead of special-casing one slug inside a card component.
 *
 * Rows with no display name fall back to a HUMANISED key (never a raw
 * `snake_case` slug) — that is a presentation fallback, not invented copy.
 */
import { supabase } from "@/integrations/supabase/client";

export function humaniseStyleKey(key: string): string {
  return key
    .replace(/[_-]+/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

/** style key -> customer-facing name, for every look in the catalogue. */
export async function listStyleDisplayNames(): Promise<Record<string, string>> {
  const { data, error } = await supabase
    .from("style_taxonomy_config")
    .select("style_id, display_name");
  if (error) return {};
  const out: Record<string, string> = {};
  for (const row of (data as { style_id: string; display_name: string | null }[]) ?? []) {
    out[row.style_id] = row.display_name?.trim() || humaniseStyleKey(row.style_id);
  }
  return out;
}
